// extracted by mini-css-extract-plugin
export var animationContainer = "_e8-0";
export var asteriskIcon = "_e8-8";
export var conversationLeftSection = "_e8-4";
export var conversationListItem = "_e8-3";
export var conversationMiddleSection = "_e8-5";
export var conversationRightSection = "_e8-6";
export var detailsContent = "_e8-1";
export var listContainer = "_e8-7";
export var modalContent = "_e8-2";